import "./SellerRegSections.scss";
import TooltipIcon from "../../../assets/images/alert-circle.png";
import {
  Autocomplete,
  Box,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Popper,
  Select,
  TextField,
  Tooltip,
  TooltipProps,
  styled,
  tooltipClasses,
} from "@mui/material";
import AppDatePicker from "../../../components/AppFilterDate/AppDatePicker/AppDatePicker";
import useScrollPosition from "../../../hooks/useScrollPosition";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CloseIcon from '../../../assets/images/gettingstarted/cancel.svg';
import { ArrowDropDown } from "@mui/icons-material";
import { useSelector } from 'react-redux';



const FormSection = ({ formData, handleChange, section, checkError, showConditionals, noneText }) => {
  const scrollPosition = useScrollPosition();

  const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: 220,
    },
  });

  const { t } = useTranslation();
  const selectedBizModels = formData?.impDetails?.subsections?.BizModel?.fields?.chooseBizModel?.content || [];
  const businessModelList = useSelector((state: any) => state.sellerReg.businessModelList);

  // Compute if any selected business model requires IATA:
  const anyIataRequired = businessModelList?.some(
    (bm) =>
      selectedBizModels.includes(bm.business_model_type) ||
        selectedBizModels.includes(bm.business_model_type_fr)
        ? bm.iata_mandatory === 1
        : null
  );
  const handleCalChange = (val, props) => {
    handleChange(val, props[0], props[1], props[2]);
  };

  const [showHideSelect, setShowHideSelect] = useState([{ key: false, value: "" }])

  const handleShowHideSelect = (label) => {
    const res = showHideSelect.map(v => {
      if (v.value === label && v.key === true) {
        return {
          key: false,
          value: label
        }
      }
      if (v.value === label && v.key === false) {
        return {
          key: true,
          value: label
        }
      }
      if (v.value !== label) {
        return {
          key: true,
          value: label
        }
      } else {
        return v
      }
    })
    setShowHideSelect(res)
  }

  useEffect(() => {
    if (scrollPosition) {
      setShowHideSelect([{ key: false, value: "" }])
    }
  }, [scrollPosition]);


  const toolTip = (curr) => {

    return (
      <Box
        sx={{
          position: "absolute",
          cursor: "pointer",
          padding: "22px 5px",
          display: 'inline-block'
        }}
      >
        <CustomWidthTooltip
          title={<div className="toolTipTable" dangerouslySetInnerHTML={{ __html: curr["tooltip"] }}></div>}
          placement="right">
          <img
            className="tooltipIcon"
            src={TooltipIcon}
            alt="Tooltip Icon"
            aria-hidden="true"
          />
        </CustomWidthTooltip>
      </Box>
    );
  };

  const getLabel = (curr) => {
    const required = curr["required"] === "true" ? " *" : "";
    return `${curr["label"]}${required}`;
  };
  const checkSubLabelLength = (label) => {
    return label.length > 100 ? "longSubLabel" : "";
  }


  if (formData[section]?.subsections) {
    let allSubsections = formData[section]?.subsections;
    let subSectionKeys = Object.keys(allSubsections);
    return (
      formData && (
        <div id="sellerRegFormPg">
          <h3>{formData[section]["heading"]}</h3>
          <div className="subSectionGrid">
            {subSectionKeys.map((sub, i) => {

              let fieldKeys = Object.keys(allSubsections[sub]["fields"]);
              const sameRow = allSubsections[sub]["weight"] % 2 === 0;
              if (sameRow) {
              }

              return (
                <div className="subsectionBox" key={sub}>
                  <h4 className="sellerRegLable">{allSubsections[sub]["label"]}</h4>
                  {allSubsections[sub]["subLabel"] && (
                    <div className={sub === 'SellerPOS' ? 'sublab' : `subLabel ${checkSubLabelLength(allSubsections[sub]["subLabel"])}`}>
                      {allSubsections[sub]["subLabel"]}
                    </div>
                  )}
                  {fieldKeys.map((field: string, i2) => {
                    if (field === "otherPOS") return null;
                    const curr = allSubsections[sub]["fields"][field];

                    if (curr["conditional"] && curr["conditional"]["type"] === "controlled" && !showConditionals.includes(field)) {
                      // Special handling for hasOtherIata field - show only when IATA is required
                      if (field === "hasOtherIata") {
                        const iataValue = formData?.[section]?.subsections?.BizModel?.fields?.iataNumber?.content || "";
                        const hasValidIata = iataValue.length === 8 && /^\d{8}$/.test(iataValue);

                        if (!anyIataRequired && !hasValidIata) {
                          return false;
                        }
                      }
                      // Only show fields that are conditional on others being filled if applicable
                      if (field !== "hasOtherIata") {
                        return false;
                      }
                    }

                    switch (curr["type"]) {
                      case "text":
                        return (
                          <FormControl fullWidth key={`${field}-t`}>

                            <TextField
                              className="formTextField"
                              label={getLabel(curr)}
                              name={curr["name"]}
                              variant="standard"
                              value={curr["content"]}
                              id={`${field}-${curr["name"]}`}
                              onChange={(e) => {
                                handleChange(e, section, sub, field);
                                checkError(curr, sub, field, section);
                              }}
                              key={field}
                              error={curr["error"] === true}
                              helperText={curr["name"] === 'iata_number' ? curr['helperText'] : curr["error"] && curr["errorMsg"]}
                              // helperText={curr["error"] && curr["errorMsg"]}
                              inputProps={{
                                onBlur: () => {
                                  checkError(curr, sub, field, section);
                                },
                              }}
                              autoFocus={i === 0 && i2 === 0}
                              required={anyIataRequired}
                            />
                            {(curr["tooltip"] && curr["content"]) === "" &&
                              toolTip(curr)}
                          </FormControl>
                        );

                      case "select":
                        return (
                          <FormControl
                            fullWidth
                            key={`${field}-t`}
                            className="selectBox"
                          >
                            <InputLabel
                              id="demo-simple-select-label"
                              key={`${field}-l`}
                            >
                              {getLabel(curr)}
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id={field}
                              variant="standard"
                              value={curr["content"]}
                              label={getLabel(curr)}
                              name={curr["name"]}
                              onChange={(e) =>
                                handleChange(e, section, sub, field)
                              }
                              key={field}
                              open={showHideSelect[0].value === curr['label'] ? showHideSelect[0].key : false}
                              onOpen={() => handleShowHideSelect(curr['label'])}
                              onClose={() => handleShowHideSelect(curr['label'])}
                              MenuProps={{
                                disableScrollLock: true
                              }}
                            >
                              {curr["options"] &&
                                curr["options"].map((option, i) => {
                                  return (
                                    <MenuItem
                                      value={option}
                                      key={`${field}-${i}`}
                                    >
                                      {option}
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                            {/* {(curr["tooltip"] && curr["content"]) === "" &&
                              toolTip(curr)} */}
                          </FormControl>
                        );

                      case "selectMultiple":
                        return (
                          <FormControl
                            fullWidth
                            key={`${field}-t`}
                            className="selectBox"
                          >
                            <InputLabel
                              id="demo-simple-select-label"
                              key={`${field}-l`}
                            >
                              {getLabel(curr)}
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id={field}
                              multiple
                              variant="standard"
                              value={[...curr["content"]]}
                              label={getLabel(curr)}
                              name={curr["name"]}
                              onChange={(e) =>
                                handleChange(e, section, sub, field)
                              }
                              key={field}
                              open={showHideSelect[0].value === curr['label'] ? showHideSelect[0].key : false}
                              onOpen={() => handleShowHideSelect(curr['label'])}
                              onClose={() => handleShowHideSelect(curr['label'])}
                              MenuProps={{
                                disableScrollLock: true
                              }}
                            >
                              {curr['allowNone'] && <MenuItem
                                value="None"
                                key={`none-${i}`}
                              >
                                {t('sellerRegistration.noneText')}
                              </MenuItem>}
                              {curr["options"] &&
                                curr["options"].map((option, i) => {
                                  return (
                                    <MenuItem
                                      value={option}
                                      key={`${field}-${i}`}
                                    >
                                      {option}
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                            {/* {(curr["tooltip"] && curr["content"]) === "" &&
                              toolTip(curr)} */}
                          </FormControl>
                        );

                      case 'autoComplete':
                        return (
                          <FormControl
                            fullWidth
                            key={`${field}-t`}
                            className="selectBox"
                          >
                            <Autocomplete
                              multiple
                              sx={{
                                '& .MuiAutocomplete-endAdornment': {
                                  top: '95%',
                                },
                                '& .MuiAutocomplete-clearIndicator': {
                                  '&:hover, &:active': {
                                    backgroundColor: 'unset'
                                  },
                                  color: '#000',
                                },
                                '& .MuiAutocomplete-popupIndicator': {
                                  '&:hover, &:active': {
                                    backgroundColor: 'unset'
                                  },
                                },
                                '& .MuiTouchRipple-root': {
                                  display: 'none'
                                },
                              }}
                              popupIcon={
                                <ArrowDropDown fontSize="large" htmlColor="#000" />
                              }
                              renderTags={(value, getTagProps) => {
                                return value.map((option, index) => (
                                  <Chip
                                    variant="outlined"
                                    label={option}
                                    sx={{
                                      height: '32px',
                                      color: '#000',
                                    }}
                                    {...getTagProps({ index })}
                                    deleteIcon={<img src={CloseIcon} alt='closeicon' height={'12px'} style={{
                                      padding: '0 3px',
                                    }} />}
                                  />
                                ));
                              }}
                              PopperComponent={(props) => (
                                <Popper {...props}
                                  id="autocomplete-popper"
                                  popperOptions={
                                    {
                                      modifiers: [
                                        {
                                          name: 'flip',
                                          options: {
                                            fallbackPlacements: [],
                                          },
                                        },
                                      ],
                                    }
                                  } />
                              )}
                              id={field}
                              value={curr['content'] || []}
                              options={curr["options"] || []}
                              getOptionLabel={(option) => option}

                              onOpen={() => handleShowHideSelect(curr['label'])}
                              onClose={() => handleShowHideSelect(curr['label'])}
                              onChange={(event, newValue) => handleChange({
                                target: {
                                  name: curr["name"],
                                  value: newValue
                                }
                              }, section, sub, field)}
                              renderInput={(params) => {
                                return <TextField
                                  {...params}
                                  variant="standard"
                                  label={getLabel(curr)}
                                  name={curr["name"]}

                                  InputLabelProps={{
                                    ...params.InputLabelProps,
                                    style: {
                                      left: 0
                                    }
                                  }}

                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <Box sx={{
                                        top: '100%',
                                        color: '#000'
                                      }}>
                                        {params.InputProps.endAdornment}
                                      </Box>
                                    ),
                                  }}
                                />
                              }}
                            />
                          </FormControl>
                        );


                      case "checkbox":
                        const currValue =
                          curr["content"] === ""
                            ? false
                            : curr["content"] === "true";
                        return (
                          <div key={`${field}-c`} > <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) =>
                                  handleChange(e, section, sub, field)
                                }
                                name={curr["name"]}
                                value={currValue}
                                checked={currValue}
                                className="formCheckbox"
                                sx={{ display: 'inline-block' }}
                              />
                            }
                            label={getLabel(curr)}
                            key={`${field}-c2`}
                          />{curr["tooltip"] && toolTip(curr)}</div>
                        );

                      case "calendar":
                        return (
                          <AppDatePicker
                            key={`${field}-cal`}
                            label={getLabel(curr)}
                            id={field}
                            keyName={field}
                            value={curr["content"]}
                            handleChange={handleCalChange}
                            props={[section, sub, field]}
                          />
                        );

                      default:
                      // code block
                    }

                    return true;
                  })}
                </div>
              );
            })}
          </div>{" "}
        </div>
      )
    );
  }
};

export default FormSection;
